import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class BuildingUpgradeItemResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("BuildingUpgradeItemResourcePackage");
    }
    public get assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/building_upgrade_item/building_upgrade_item_1x.atlas.json");
    }
    public get assets_views_building_upgrade_item_tokens_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["tokens.png"];
    }
    public get assets_views_building_upgrade_item_blue_light_vertical_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["blue_light_vertical.png"];
    }
    public get assets_views_building_upgrade_item_blue_light_top_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["blue_light_top.png"];
    }
    public get assets_views_building_upgrade_item_initial_reward_frame_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["initial_reward_frame.png"];
    }
    public get assets_views_building_upgrade_item_bottom_yellow_light_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["bottom_yellow_light.png"];
    }
    public get assets_views_building_upgrade_item_green_light_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["green_light.png"];
    }
    public get assets_views_building_upgrade_item_token_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["token.png"];
    }
    public get assets_views_building_upgrade_item_landlord_icon_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["landlord_icon.png"];
    }
    public get assets_views_building_upgrade_item_piggy_icon_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["piggy_icon.png"];
    }
    public get assets_views_building_upgrade_item_info_icon_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["info_icon.png"];
    }
    public get assets_views_building_upgrade_item_building_icon_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["building_icon.png"];
    }
    public get assets_views_building_upgrade_item_piggy_club_icon_png(): Texture {
        return this.assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_json.textures["piggy_club_icon.png"];
    }
    public get assets_views_building_upgrade_item_building_upgrade_item_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/building_upgrade_item/building_upgrade_item_1x.atlas.png");
    }
}

